/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import { IMyComponentLifecycle } from './interface/IMyComponentLifecycle';
import { IPresenter } from './interface/IPresenter';
import { IModel } from './interface/IModel';
import { IViewDelegate } from './interface/IViewDelegate';
import { Disposer } from './type';
import EmptyModel from '@src/js/separate-logic/empty-model';

export default class BasePresenter implements IPresenter, IMyComponentLifecycle {
    public static presenterID = 0;

    protected model: IModel;
    private viewDelegate: IViewDelegate;
    private PID: number;

    // 存储不同状态时的model值
    private nextModel: any;
    private preModel: any;

    public constructor(model: IModel, viewDelegate: IViewDelegate) {
        // eslint-disable-next-line no-plusplus
        this.PID = BasePresenter.presenterID++;
        this.viewDelegate = viewDelegate;
        this.model = model;
        model.initModel(viewDelegate.getProps(), viewDelegate.getStore());
    }

    public init(props: any, store?: any) {
    }

    public componentDidMount(): void {
    }

    public componentDidUpdate(prevProps, prevModel): void {
    }

    public componentWillReceiveProps(nextProps): void {
    }

    public componentWillUnmount(): void {
    }

    public componentWillUpdate(nextProps, nextModel): void {
    }

    public shouldComponentUpdate(nextProps, nextModel): boolean {
        return true;
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    public setModel(model: object,  callback?: () => void) {
        if (this.isEmptyModel()) {
            throw new Error('is EmptyModel, need connect a custom Model');
        }
        if (!this.nextModel) {
            this.nextModel = { ...this.model };
        }
        Object.keys(model).forEach((keyItem) => {
            this.nextModel[keyItem] = model[keyItem];
        });
        this.viewDelegate?.setUpdate(callback);
    }

    /**
     * 通过nextModel,更新当前model数据
     */
    public updateModelWithNextModel() {
        this.preModel = { ...this.model };
        this.nextModel && Object.keys(this.nextModel).forEach((keyItem) => {
            this.model[keyItem] = this.nextModel[keyItem];
        });
        this.nextModel = null;
    }

    public clearPreModel() {
        this.preModel = null;
    }

    public getNextModel() {
        if (!this.nextModel) {
            this.nextModel = { ...this.model };
        }
        return this.nextModel;
    }

    public getPreModel() {
        if (!this.preModel) {
            this.preModel = { ...this.model };
        }
        return this.preModel;
    }

    public getModel() {
        if (this.isEmptyModel()) {
            return {};
        }
        const modelObj = { ...this.model };
        return modelObj;
    }

    public getChildRef(name: string): any {
        return this.viewDelegate?.getChildRef(name);
    }

    public get props() {
        return this.viewDelegate?.getProps();
    }

    public set props(obj) {
        throw new Error('not allowed set props');
    }

    public getStore(): any {
        return this.viewDelegate?.getStore();
    }

    public forceUpdate(callback?: () => void) {
        this.viewDelegate?.forceUpdate(callback);
    }

    public disposeOnUnmount<TF extends Disposer | Disposer[]>(fn: TF): TF {
        return this.viewDelegate?.disposeOnUnmount(fn);
    }

    private isEmptyModel() {
        return this.model instanceof EmptyModel;
    }
}
